import React from "react";
import { Box, Typography } from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { styled } from "@mui/material/styles";

const Step = ({ label, time, active, completed, color, isLast }) => (
  <Box display="flex" alignItems="flex-start" mb={1}>
    <Box display="flex" flexDirection="column" alignItems="center" mr={2}>
      {completed ? (
        <RadioButtonCheckedIcon sx={{ color, fontSize: 24 }} />
      ) : (
        <RadioButtonUncheckedIcon sx={{ color, fontSize: 24 }} />
      )}
      {!isLast && (
        <Box
          sx={{
            width: "2px",
            height: 70, // fixed height ensures line visibility
            bgcolor: completed ? color : "#A7A7A7",
            mt: 0.5,
          }}
        />
      )}
    </Box>
    <Box>
      <Typography
        variant="body1"
        sx={{
          color: active ? "var(--neutral-black)" : "var(--neutral-500)",
          fontWeight: 600,
          fontSize: "16px",
          lineHeight: "150%",
          textAlign: "left",
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 600,
          fontSize: "12px",
          lineHeight: "167%",
          textAlign: "left",
          color: "var(--neutral-600)",
        }}
      >
        {time}
      </Typography>
    </Box>
  </Box>
);

const StepIndicator = ({ orderStatus }) => {
  const isStatusAvailable = (statuses, value) => statuses?.includes(value);

  const steps = [
    {
      label: "Order Submitted",
      statusKey: "Submitted",
      time: orderStatus?.order_submitted_at,
      color: "#C51605",
    },
    {
      label: "Order Confirmed",
      statusKey: "Confirmed",
      time: orderStatus?.order_processed_at,
      color: "#FF7B00",
    },
    {
      label: "Order Preparing",
      statusKey: "Order Preparing",
      time: orderStatus?.order_shipped_at,
      color: "#FFD700",
    },
    {
      label:
        orderStatus?.delivery_mode === "Pick Up"
          ? "Ready for pickup"
          : "Out For Delivery",
      statusKey:
        orderStatus?.delivery_mode === "Pick Up"
          ? "Cake Ready"
          : "Out For Delivery",
      time:
        orderStatus?.driver_orders?.picked_up_at ||
        orderStatus?.shop_orders?.accepted_at,
      color: "#80b918",
    },
    {
      label: "Delivered",
      statusKey: "Delivered",
      time: orderStatus?.order_delivered_at,
      color: "green",
    },
  ];

  return (
    <TimelineCard>
      <Title>Tracking Timeline</Title>
      <Box display="flex" flexDirection="column" sx={{ mt: 1 }}>
      {steps.map((step, index) => (
        <Step
          key={index}
          label={step.label}
          time={step.time}
          active={isStatusAvailable(
            orderStatus?.preview_status,
            step.statusKey
          )}
          completed={!!step.time}
          color={step.color}
          isLast={index === steps.length - 1}
        />
      ))}

      {orderStatus?.order_status === "Cancelled" && (
        <Box
          mt={1}
          p={2}
          sx={{
            backgroundColor: "#3646491A",
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <Typography color="#FF272F" fontWeight={500}>
            Sorry, Order got {orderStatus?.order_status}
          </Typography>
        </Box>
      )}
      </Box>
    </TimelineCard>
  );
};

const TimelineCard = styled(Box)(() => ({
  marginTop: "16px",
  border: "1px solid rgba(183, 124, 10, 0.22)",
  borderRadius: "16px",
  padding: "16px 18px",
  background: "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(255,250,242,0.96) 100%)",
  boxShadow: "0 10px 24px rgba(173, 132, 61, 0.08)",
}));

const Title = styled(Typography)(() => ({
  fontSize: "18px",
  fontWeight: 700,
  color: "var(--neutral-black)",
  textAlign: "left",
}));

export default StepIndicator;
